import type { Research } from '@/api/types';

import { VerdictPill } from '../ideaUi';
import { ScoreValue } from '@/ui/ScoreValue';

/** The model's verdict over the total the scores add up to: read together, kept apart (the verdict is not derived from the total). */
export function Verdict({ research }: { research: Research }) {
  return (
    <section className="metric-tile usage-card idea-tile-verdict" aria-label="Verdict and total score">
      <span className="usage-card-of">Verdict</span>
      <VerdictPill verdict={research.verdict} confidence={research.confidence} />
      <div
        className="idea-total"
        title="Weighted average of the dimension scores with today's weights; the Points column adds up to it. The verdict is the model's own call."
      >
        <ScoreValue value={research.total} />
        <span className="usage-card-of">Total score</span>
      </div>
    </section>
  );
}
